declare namespace $ {

	type $shm_hitalama_map_widget_float_form2_relation_form__host_shm_hitalama_map_widget_float_form2_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form2['form_self'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_form2_relation_form['host'] >
	>
	type $shm_hitalama_map_widget_float_form2_relation_form__page_index_shm_hitalama_map_widget_float_form2_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form2['relation_page_index'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_form2_relation_form['page_index'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_form2_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_form2_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form2['form_workspace_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_map_widget_float_form2 extends $shm_hitalama_map_widget_float_form_custom {
		relation_page_index( id: any): number
		Relation_form( id: any): $shm_hitalama_map_widget_float_form2_relation_form
		Relation_panel( id: any): $mol_view
		form_workspace_content( ): readonly($mol_view)[]
		Form_workspace( ): $mol_view
		page_content( ): readonly(any)[]
		form_self( ): any
	}
	
	export class $shm_hitalama_map_widget_float_form2_relation_form extends $shm_hitalama_map_widget_float_table_form {
		host( ): $shm_hitalama_map_widget_float_form2
		page_index( ): number
	}
	
}

//# sourceMappingURL=form2.view.tree.d.ts.map